// update state
const setTaskIdAction = (payload) => {
    return {
            type: "TASKID",
            payload
        }

}

export default setTaskIdAction;




// WEBPACK FOOTER //
// ./src/actions/setTaskIdAction.js